import '@hb/hb-gallery/index.css';
import '../styles/previewImage.scss';
const hdfGallery = require('@hb/hb-gallery');
const jsBridge = require('@hb/hb-jsbridge');

const previewImage = {
  /**
 * 添加大图预览
 * @param {*} selector 图片元素选择器 或者dom数组
 * attr 查看大图链接的属性
 */
  init({ selector = 'img', env = 'web', enableJsbridge = false, attr = 'data-src' }) {
    let imgs = null;
    if (typeof selector === 'string') {
      imgs = document.querySelectorAll(selector);
      this._addFullScreenEvent(imgs, env, enableJsbridge, attr);
    }
    if (selector instanceof NodeList) {
      this._addFullScreenEvent(selector, env, enableJsbridge, attr);
    }
  },
  // 添加大图预览事件
  _addFullScreenEvent(imgs, env, enableJsbridge, attr) {
    if (!imgs) {
      return;
    }
    // 禁止鼠标右键
    document.οncοntextmenu = function (e) {
      e.preventDefault();
    };
    const galleyItems = [];
    Array.from(imgs).forEach(img => {
      // 不可见元素直接跳过
      if (img && !this._isVisible(img)) {
        return;
      }
      galleyItems.push({
        src: img.getAttribute(attr) || img.getAttribute('src')
      });
      // 添加点击事件
      const _index = galleyItems.length - 1;
      img.addEventListener('click', () => {
        if (env === 'app') {
          if (enableJsbridge) {
            jsBridge.callCHandler({
              nativeMethod: 'onImagePreview',
              data: {
                urls: galleyItems.map(item => item.src),
                index: _index
              }
            });
          } else {
            const imgUrl = img.getAttribute(attr) || img.getAttribute('src');
            window.location.href = `https://mobile-api.haodf.com/article/showimage?imgurl=${encodeURIComponent(imgUrl)}`;
          }
        } else {
          hdfGallery.show(galleyItems, {
            index: _index
          });
        }
      });
    });
  },
  /**
 * 元素是否可见
 * @param {*} el 不需要了 之前是有visible-img 不可见元素
 * @returns
 */
  _isVisible(el) {
    const cmpStyle = getComputedStyle(el);
    return cmpStyle.display !== 'none' && cmpStyle.visibility !== 'hidden';
  }
};
export default previewImage;
